import React, { useEffect, useState } from "react";
import EthImage from "../images/ethereum.svg";
import { Link, useSearchParams } from "react-router-dom";
import Skeleton from "../components/UI/Skeleton";
import axios from "axios";

const ItemDetails = () => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const nftId = searchParams.get("nftId");

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(
        `https://us-central1-nft-cloud-functions.cloudfunctions.net/itemDetails?nftId=${nftId}`
      )
      .then((res) => {
        setItem(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [nftId]);

  return (
    <div id="wrapper">
      <div className="no-bottom no-top" id="content">
        <div id="top"></div>
        <section aria-label="section" className="mt90 sm-mt-0">
          <div className="container">
            <div className="row">
              <div className="col-md-6 text-center">
                {loading ? (
                  <Skeleton width="100%" height="350px" borderRadius="10px" />
                ) : (
                  <img
                    src={item?.nftImage}
                    className="img-fluid img-rounded mb-sm-30 nft-image"
                    alt=""
                  />
                )}
              </div>
              <div className="col-md-6">
                <div className="item_info">
                  {loading ? (
                    <>
                      <Skeleton width="80%" height="30px" borderRadius="4px" />
                      <div className="item_info_counts" style={{ marginTop: "16px" }}>
                        <Skeleton width="60px" height="20px" borderRadius="4px" />
                        <Skeleton width="60px" height="20px" borderRadius="4px" style={{ marginLeft: "10px" }} />
                      </div>
                      <div style={{ marginTop: "16px" }}>
                        <Skeleton width="100%" height="14px" borderRadius="4px" />
                        <Skeleton width="90%" height="14px" borderRadius="4px" style={{ marginTop: "8px" }} />
                        <Skeleton width="80%" height="14px" borderRadius="4px" style={{ marginTop: "8px" }} />
                      </div>
                      <div className="d-flex flex-row" style={{ marginTop: "24px" }}>
                        <div className="mr40">
                          <Skeleton width="50px" height="14px" borderRadius="4px" />
                          <div className="item_author" style={{ marginTop: "8px" }}>
                            <div className="author_list_pp">
                              <Skeleton width="50px" height="50px" borderRadius="50%" />
                            </div>
                            <div className="author_list_info" style={{ marginLeft: "60px" }}>
                              <Skeleton width="100px" height="14px" borderRadius="4px" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="de_tab tab_simple" style={{ marginTop: "24px" }}>
                        <Skeleton width="60px" height="14px" borderRadius="4px" />
                        <div className="item_author" style={{ marginTop: "8px" }}>
                          <div className="author_list_pp">
                            <Skeleton width="50px" height="50px" borderRadius="50%" />
                          </div>
                          <div className="author_list_info" style={{ marginLeft: "60px" }}>
                            <Skeleton width="100px" height="14px" borderRadius="4px" />
                          </div>
                        </div>
                        <div className="spacer-40"></div>
                        <Skeleton width="50px" height="14px" borderRadius="4px" />
                        <div style={{ marginTop: "8px" }}>
                          <Skeleton width="120px" height="30px" borderRadius="4px" />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <h2>{item?.title}</h2>
                      <div className="item_info_counts">
                        <div className="item_info_views">
                          <i className="fa fa-eye"></i>
                          {item?.views}
                        </div>
                        <div className="item_info_like">
                          <i className="fa fa-heart"></i>
                          {item?.likes}
                        </div>
                      </div>
                      <p>{item?.description}</p>
                      <div className="d-flex flex-row">
                        <div className="mr40">
                          <h6>Owner</h6>
                          <div className="item_author">
                            <div className="author_list_pp">
                              <Link to={`/author?authorId=${item?.ownerId}`}>
                                <img className="lazy" src={item?.ownerImage} alt="" />
                                <i className="fa fa-check"></i>
                              </Link>
                            </div>
                            <div className="author_list_info">
                              <Link to={`/author?authorId=${item?.ownerId}`}>
                                {item?.ownerName}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="de_tab tab_simple">
                        <div className="de_tab_content">
                          <h6>Creator</h6>
                          <div className="item_author">
                            <div className="author_list_pp">
                              <Link to={`/author?authorId=${item?.creatorId}`}>
                                <img className="lazy" src={item?.creatorImage} alt="" />
                                <i className="fa fa-check"></i>
                              </Link>
                            </div>
                            <div className="author_list_info">
                              <Link to={`/author?authorId=${item?.creatorId}`}>
                                {item?.creatorName}
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="spacer-40"></div>
                        <h6>Price</h6>
                        <div className="nft-item-price">
                          <img src={EthImage} alt="" />
                          <span>{item?.price}</span>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ItemDetails;
